// @ts-nocheck
import * as Types from '../../../__generated__/graphqlTypes';

import { gql } from '@apollo/client';
export type ConfigurationHeader_CheckoutConfigFragment = { __typename?: 'CheckoutConfig', id: string, name?: string | null | undefined, status: Types.CheckoutConfigStatus, reservedAt?: Types.Scalars['DateTime']['input'] | null | undefined, expiresAt?: Types.Scalars['Date']['input'] | null | undefined, aggregateVersion?: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined } | null | undefined, productOffering?: { __typename?: 'ProductOffering', id: string, aggregateCheckout?: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined } | null | undefined } | null | undefined };

export const ConfigurationHeader_CheckoutConfigFragmentDoc = gql`
    fragment ConfigurationHeader_CheckoutConfig on CheckoutConfig {
  id
  name
  status
  reservedAt
  expiresAt
  aggregateVersion {
    id
    version
  }
  productOffering {
    id
    aggregateCheckout {
      id
      version
    }
  }
}
    `;